"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskStatusActions = exports.TaskStatusActionEvent = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const ErrorMetadataView_1 = require("../../errors/ErrorMetadataView");
const useWorkflowRequiredFields_1 = require("../../hooks/useWorkflowRequiredFields");
const Workflow_context_1 = require("../../Workflow.context");
const useFindTask_1 = require("../hooks/useFindTask");
const useTaskFields_1 = require("../hooks/useTaskFields");
const useUpdateTask_1 = require("../hooks/useUpdateTask");
const Task_event_1 = require("../Task.event");
const Task_machine_1 = require("../Task.machine");
var TaskStatusActionEvent;
(function (TaskStatusActionEvent) {
    TaskStatusActionEvent["TransitionAttempt"] = "task-status-action:transition-attempt";
})(TaskStatusActionEvent = exports.TaskStatusActionEvent || (exports.TaskStatusActionEvent = {}));
const StyledStatusActions = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const StyledButton = (0, styled_components_1.default)(core_1.Button) `
  &.Mui-disabled {
    /* allow clickable button with disabled colors */
    cursor: pointer;
    pointer-events: auto;
  }
`;
const TaskStatusActions = props => {
    var _a;
    const { task: initialTask, taskEntity, disabled, className, containerProps, onChange: onChangeProp } = props;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const user = (0, user_ui_1.useUserContext)().user;
    const { servicePlugins } = (0, Workflow_context_1.useWorkflowContext)();
    const onChangeRef = (0, react_1.useRef)(onChangeProp);
    onChangeRef.current = onChangeProp;
    const [task, setTask] = (0, react_1.useState)(Object.assign({}, initialTask));
    const [didUpdate, setDidUpdate] = (0, react_1.useState)(false);
    const [enabledEvents, setEnabledEvents] = (0, react_1.useState)([]);
    const { render, stateNode, canTransition, handleTransition } = (0, Task_machine_1.useGetWorkflowMachineState)(task);
    const { task: loadedTask, isLoading: isFinding, error: findError, findTask } = (0, useFindTask_1.useFindTask)(task.id);
    const { data: updatedTask, isLoading: isUpdating, error: updateError, updateTask } = (0, useUpdateTask_1.useUpdateTask)(initialTask.id || 0);
    const { getValidator } = (0, useWorkflowRequiredFields_1.useWorkflowRequiredFields)(stateNode);
    // trigger no workflow warning
    (0, useTaskFields_1.useTaskFields)(task);
    const isLoading = isFinding || isUpdating;
    const error = findError || updateError;
    // filter active and assigned subTasks
    // inactive subTasks may be present with active ones
    // since older subTasks can now be kept from previous states
    const assignedSubTasks = (task.children || []).filter(subTask => {
        return (user &&
            subTask.user &&
            user.id === subTask.user.id &&
            (!subTask.statePath || (0, workflow_core_1.compareTaskStatus)(subTask.statePath, task.status)));
    });
    const ErrorMetadataView = (0, react_1.useMemo)(() => {
        const errorPlugins = [];
        for (const plugin of servicePlugins) {
            plugin.error && errorPlugins.push(plugin.error);
        }
        return (0, ErrorMetadataView_1.createErrorMetadataView)(...errorPlugins);
    }, [servicePlugins]);
    const context = (0, react_1.useMemo)(() => {
        return { task, taskEntity, user };
    }, [task, taskEntity, user]);
    // canTransition call returns a promise, so save result in state
    const updateEnabled = (0, react_1.useCallback)((id, isEnabled) => {
        setEnabledEvents(enabledEvents => {
            const index = enabledEvents.findIndex(enabled => enabled.id === id);
            const newEnabled = { id, canTransition: isEnabled };
            if (index < 0) {
                return enabledEvents.concat(newEnabled);
            }
            const copy = Array.from(enabledEvents);
            copy.splice(index, 1, newEnabled);
            return copy;
        });
    }, []);
    const isDisabled = (0, react_1.useCallback)((id) => {
        var _a;
        return (disabled || !((_a = enabledEvents.find(event => event.id === id)) === null || _a === void 0 ? void 0 : _a.canTransition));
    }, [disabled, enabledEvents]);
    const onChange = (0, react_1.useCallback)((task) => {
        var _a;
        setDidUpdate(true);
        (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, task);
        Task_event_1.TaskEvent.dispatch(Task_event_1.TaskEventType.ChangeStatus, { task });
    }, []);
    // update task state
    (0, react_1.useEffect)(() => {
        setTask(Object.assign({}, initialTask));
    }, [initialTask]);
    // update task notify parent component
    (0, react_1.useEffect)(() => {
        if (updatedTask) {
            setTask(updatedTask);
            onChange(updatedTask);
        }
    }, [updatedTask, onChange]);
    // for reloading the task if subtask is updated
    (0, react_1.useEffect)(() => {
        if (loadedTask) {
            setTask(loadedTask);
            onChange(loadedTask);
        }
    }, [loadedTask, onChange]);
    (0, react_1.useEffect)(() => {
        const updateEnabledEvents = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            (_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.events) === null || _a === void 0 ? void 0 : _a.forEach((event) => __awaiter(void 0, void 0, void 0, function* () {
                let isEnabled = false;
                try {
                    isEnabled = !!(yield canTransition(event, context));
                }
                catch (_b) { }
                updateEnabled(event.id, isEnabled);
            }));
        });
        updateEnabledEvents();
    }, [context, stateNode, canTransition, updateEnabled]);
    return (react_1.default.createElement(StyledStatusActions, Object.assign({}, containerProps, { className: className }), (_a = stateNode === null || stateNode === void 0 ? void 0 : stateNode.events) === null || _a === void 0 ? void 0 :
        _a.map(event => {
            const disabled = isLoading || isDisabled(event.id);
            const validate = getValidator(event.name);
            const isValidRequiredFields = validate.object(taskEntity);
            const isVisible = assignedSubTasks.length === 0 ||
                (assignedSubTasks.length > 0 && !disabled);
            if (!isVisible || !event.name) {
                return null;
            }
            return (react_1.default.createElement(core_1.Tooltip, { arrow: true, key: event.name, placement: 'bottom', title: !isLoading && disabled && !isValidRequiredFields
                    ? 'This transition is disabled because some required fields ' +
                        'have not been filled. Please click the button to see the fields.'
                    : '' },
                react_1.default.createElement(StyledButton, { color: 'primary', variant: 'contained', className: disabled ? 'Mui-disabled' : undefined, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        // skip if disbaled
                        if (disabled) {
                            // dispatch to handle disabled transition attempt
                            // e.g. display required fields error on forms
                            core_ui_1.CoreEvent.dispatch(TaskStatusActionEvent.TransitionAttempt, { eventName: event.name });
                            return;
                        }
                        const oldStatePath = stateNode === null || stateNode === void 0 ? void 0 : stateNode.path;
                        try {
                            const newState = yield handleTransition(event, context);
                            if (!newState || (newState === null || newState === void 0 ? void 0 : newState.path) === oldStatePath) {
                                return;
                            }
                            updateTask({
                                status: newState.path,
                                event: event.toJson(),
                                reason: newState.context.reason,
                                subTaskUserIds: newState.context.subTaskUserIds,
                                clearFieldItems: newState.context.clearFieldItems
                            });
                        }
                        catch (error) {
                            console.error('[TaskStatusActions]', error);
                        }
                    }) }, event.name)));
        }),
        assignedSubTasks.map(subTask => (react_1.default.createElement(exports.TaskStatusActions, { key: subTask.id, task: subTask, disabled: disabled, taskEntity: taskEntity, onChange: (subTask) => __awaiter(void 0, void 0, void 0, function* () {
                const taskKey = task.key || `TASK-${task.id}`;
                const subTaskKey = subTask.key || `SUBTASK-${subTask.id}`;
                // update subTask in task.children
                // so that checks with subTask statuses will succeed
                if (!task.children) {
                    task.children = [];
                }
                const index = task.children.findIndex(child => child.id === subTask.id);
                if (index === -1) {
                    console.debug('[actions] %s (%o) push %s (%o)', taskKey, task.status, subTaskKey, subTask.status);
                    task.children.push(subTask);
                }
                else {
                    console.debug('[actions] %s (%o) update %s (%o->%o)', taskKey, task.status, subTaskKey, task.children[index].status, subTask.status);
                    Object.assign(task.children[index], subTask);
                }
                // after updating subTasks, run transient events
                // for parent task to trigger state invoke actions
                try {
                    // no need to call updateTask() since parent tasks
                    // are already updated by the subTask's updateTask() call
                    const oldStatePath = stateNode === null || stateNode === void 0 ? void 0 : stateNode.path;
                    // pass updated context
                    const newState = yield handleTransition(undefined, {
                        task,
                        taskEntity,
                        user
                    });
                    console.debug('[actions] %s transition %o->%o', taskKey, oldStatePath, newState === null || newState === void 0 ? void 0 : newState.path);
                }
                catch (error) {
                    console.error('[actions] %s (%o) %s (%o) error: %o', taskKey, task.status, subTaskKey, subTask.status, error);
                }
                finally {
                    // reload the parent task
                    findTask();
                }
            }) }))),
        (isUpdating || isLoading) && react_1.default.createElement(core_1.CircularProgress, { size: 20 }),
        render,
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: didUpdate, onClose: () => setDidUpdate(false) }, "Status successfully updated."),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!error }, (error === null || error === void 0 ? void 0 : error.message) || 'An error occurred while updating the status.'),
        react_1.default.createElement(ErrorMetadataView, { error: updateError })));
};
exports.TaskStatusActions = TaskStatusActions;
exports.default = exports.TaskStatusActions;
//# sourceMappingURL=TaskStatusActions.js.map